@if (list.isHrProOrUpsellVisible()) {
  <decision-list-widget
    [title]="'New hires' | translate"
    [state]="list.state()"
    [badgeLabel]="badgeLabel() | translate: { count: list.count() }"
    [clearMessage]="'All new hires are on track. Nothing waiting on you.' | translate"
    [errorMessage]="'We couldn\'t load your new hires.' | translate"
    [scopeLocation]="list.scopeLocation()"
    (retry)="list.reload()"
    (unlock)="list.openUpsell()"
  >
    @for (row of list.rows(); track row.hireId) {
      <li class="flex min-h-12 items-center gap-sm border-0 border-b border-solid border-default px-md py-sm">
        <span class="w-1/3 min-w-0 flex-none truncate text-sm text-default" data-hj-suppress>{{ row.name }}</span>
        <div class="flex min-w-0 flex-1 flex-col">
          <span class="text-sm" [class.text-danger]="row.isExpired" [class.font-semibold]="row.isExpired">{{
            row.statusLabel | translate
          }}</span>
          @if (row.waitingSince) {
            <span class="text-xs text-subtle">{{
              row.waitingSince.label | translate: { time: (row.waitingSince.date | relativeDate) }
            }}</span>
          }
        </div>
        <span class="flex-none text-right"
          ><a class="text-sm font-semibold text-brand" [routerLink]="row.link"
            >{{ row.actionLabel | translate }} <span class="sr-only" data-hj-suppress>{{ row.name }}</span></a
          ></span
        >
      </li>
    }
  </decision-list-widget>
}
